// index.tsx

import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { DatatableProps } from "../../data/interface";

const Datatable: React.FC<
  DatatableProps & {
    rowKey?: string | ((record: any) => string),
    onRowSelect?: (rows: any[]) => void
  }
> = ({
  columns,
  dataSource,
  Selection,
  totalEmployees,
  currentPage,
  setCurrentPage,
  limit,
  setLimit,
  onSearch,
  searchText = "",
  showSearchInput,
  rowKey,
  onRowSelect
}) => {
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    const [Selections, setSelections] = useState<any>(true);
    const [filteredDataSource, setFilteredDataSource] = useState(dataSource);
    const [searchQuery, setSearchQuery] = useState(searchText);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);

    const rowSelection = {
      selectedRowKeys,
      onChange: (keys: any[], rows: any[]) => {
        setSelectedRowKeys(keys);
        setSelectedRows(rows); // save full row objects here
        onRowSelect?.(rows);
      },
      // getCheckboxProps: (record: any) => ({
      //   disabled: record.regularisation_status !== "PENDING",
      // }),
    };

    const handleSearch = (value: string) => {
      setSearchQuery(value);
      onSearch?.(value);
      const filteredData = dataSource.filter((record) =>
        Object.values(record).some((field) =>
          String(field).toLowerCase().includes(value.toLowerCase())
        )
      );
      setFilteredDataSource(filteredData);
    };
    useEffect(() => {
      setSelections(Selection);
    }, [Selection]);

    useEffect(() => {
      setFilteredDataSource(dataSource);
    }, [dataSource]);

    const computedRowKey = rowKey || ((record: any) => record.employee_id + record.attendance_regn_date);
    return (
      <>
        <div className="table-top-data">
          <div className="row p-3">
            <div className="col-sm-12 col-md-6" />
            <div className="col-sm-12 col-md-6">
              <div className="dataTables_filter text-end mb-0">
                <label>
                  {showSearchInput && <input
                    type="search"
                    className="form-control form-control-sm"
                    placeholder="Search"
                    value={searchQuery}
                    // onChange={(e) => onSearch?.(e.target.value)}
                    onChange={(e) => handleSearch(e.target.value)}
                  />}

                </label>
              </div>
            </div>
          </div>
        </div>

        <Table
          className="table datanew dataTable no-footer"
          rowKey={computedRowKey}
          rowSelection={Selections ? rowSelection : undefined}
          rowHoverable={false}
          columns={columns}
          // dataSource={dataSource}
          dataSource={filteredDataSource}
          pagination={{
            current: currentPage,
            pageSize: limit,
            locale: { items_per_page: "" },
            nextIcon: <i className="ti ti-chevron-right" />,
            prevIcon: <i className="ti ti-chevron-left" />,
            defaultPageSize: 5,
            showSizeChanger: true,
            total: totalEmployees ?? 0,
            pageSizeOptions: ["5", "10", "20", "30"],
            onChange: (page, pageSize) => {
              setCurrentPage?.(page);
              setLimit?.(pageSize);
            },
          }}
        />
      </>
    );
  };

export default Datatable;
